import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';

import { setOrtActive } from '../../actions/actions';
import ToggleButton from '../../components/ToggleButton';

const Waechter = props => (
  <div className="Waechter">
    <ToggleButton
      name="Waechter"
      onToggle={value => props.setWaechterActive(value)}
      defaultChecked={props.waechter.active}
    />
    <RouterLink to={`/orte/${props.waechter.name}`} className="Waechter-link">
      <img src="/images/shield.png" alt="Wächter Icon" className="Waechter-shield" />
      <div className="Waechter-text">
        <b>{props.waechter.name}</b> <br />
        Ihr Standort + {props.waechter.radius}km
      </div>
      <img className="Waechter-more" src="/images/arrow-white.png" alt="Wächter bearbeiten" />
    </RouterLink>
  </div>
);

Waechter.propTypes = {
  setWaechterActive: PropTypes.func.isRequired,
  waechter: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  const waechter = state.orte.filter(ort => ort.name === 'Mein Wächter')[0];
  return {
    waechter,
  };
};

const mapDispatchToProps = dispatch => ({
  setWaechterActive: value => {
    dispatch(setOrtActive('Mein Wächter', value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Waechter);



// WEBPACK FOOTER //
// ./src/js/routes/Orte/Waechter.js